<template>
    <div>
        <el-form class="evaluation-form-scoped" label-width="200px" style="position:relative">
            <el-form-item label="是否通过" required>
                <el-radio-group v-model="form.userViewpoint" ref="userViewpoint">
                    <el-radio v-for="(item, index) in viewPointOptions" class="mr-20" :label="item.value" :key="index" v-if="item.value != '-1'">{{item.text}}</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item v-if="['12','13'].includes(scoreType) && turn === '0'" label="综合能力" required class="inner-row inner-row--pma">
                <el-row
                    v-for="scoreMapItem in scoreMapList.slice(0,6)"
                    :key="scoreMapItem.name"
                >
                    <el-col class="shorter inner-td required" :span="4">{{ scoreMapItem.name }}</el-col>
                    <el-col class="shorter" :span="20">
                        <el-radio-group v-model="form[scoreMapItem.prop]" :ref="scoreMapItem.prop" class="score-group">
                            <el-radio
                                v-for="n in 5"
                                :key="n"
                                :label="n + ''"
                                class="score-item"
                            >{{ n }}</el-radio> <!-- @mouseover.native="form[scoreMapItem.prop] = n + ''" -->
                        </el-radio-group>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item v-if="['12','13'].includes(scoreType) && turn === '0'" label="个人素质" required class="inner-row inner-row--pma">
                <el-row
                    v-for="scoreMapItem in scoreMapList.slice(6,9)"
                    :key="scoreMapItem.name"
                >
                    <el-col class="shorter inner-td required" :span="4">{{ scoreMapItem.name }}</el-col>
                    <el-col class="shorter" :span="20">
                        <el-radio-group v-model="form[scoreMapItem.prop]" :ref="scoreMapItem.prop" class="score-group">
                            <el-radio
                                v-for="n in 5"
                                :key="n"
                                :label="n + ''"
                                class="score-item"
                            >{{ n }}</el-radio>
                        </el-radio-group>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item v-if="scoreType === '12' && turn === '0'" label="专业能力" required >
                <el-input class="text-content" :maxlength="2000" placeholder="（重点考察：计划制定、进度跟进、风险管理、干系人管理、团队配合情况等）" type="textarea" v-model="form.professionalProjMgr" ref="professionalProjMgr"></el-input>
            </el-form-item>
            <el-form-item v-if="scoreType === '13' && turn === '0'" label="专业能力" required class="inner-row inner-row--pma">
                <el-row
                    v-for="skillMap in skillMapList"
                    :key="skillMap.name"
                >
                    <el-col class="inner-td required" :span="4">{{ skillMap.name }}</el-col>
                    <el-col :span="20">
                        <el-input class="text-content" :maxlength="2000" :placeholder="skillMap.placeholder" type="textarea" v-model="form[skillMap.prop]" :ref="skillMap.prop"></el-input>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item v-if="['12','13'].includes(scoreType) && turn === '0'" label="其他" required class="inner-row inner-row--pma">
                <el-row
                    v-for="otherMap in otherMapList"
                    :key="otherMap.name"
                >
                    <el-col class="shorter inner-td" :class="{ 'required': otherMap.required }" :span="4">{{ otherMap.name }}</el-col>
                    <el-col class="shorter" :span="20">
                        <el-input class="text-content" :maxlength="500" placeholder="请输入" v-model="form[otherMap.prop]" :ref="otherMap.prop"></el-input>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item v-if="['12','13'].includes(scoreType)" label="综合评价" required >
                <el-input class="text-content" :maxlength="2000" placeholder="请输入评价内容" type="textarea" v-model="form.content" ref="content"></el-input>
            </el-form-item>
            <el-form-item v-if="turn === '0'" label="当前薪资" :required="form.userViewpoint !== '3' && form.userViewpoint!== '4'" class="inner-row" >
                <el-row>
                    <el-col class="inner-td" :span="4">月基本薪资</el-col>
                    <el-col :span="4"><el-input ref="monthBaseSalary" class="text-content" :maxlength="20" placeholder="建议注明 税前/税后" type="textarea" v-model="form.monthBaseSalary"></el-input></el-col>
                    <el-col class="inner-td" :span="4">薪资一年发放月数</el-col>
                    <el-col :span="4"><el-input ref="monthCount" :maxlength="20" class="text-content" placeholder="填写实际月份数即可，如一年薪资发放16个月则填写：16" type="textarea" v-model="form.monthCount"></el-input></el-col>
                    <el-col class="inner-td" :span="4">其他福利补充</el-col>
                    <el-col :span="4"><el-input ref="otherWelfare" :maxlength="100" class="text-content" placeholder="如：包三餐、包住宿、每月项目奖金、其他奖金等" type="textarea" v-model="form.otherWelfare"></el-input></el-col>
                </el-row>
            </el-form-item>
            <el-form-item v-if="turn === '0'" label="期望薪资" :required="form.userViewpoint !== '3' && form.userViewpoint!== '4'"  >
                <el-input class="text-content" placeholder="根据候选人实际要求填写即可，请尽可能详细；如年薪XX万、月薪6k*13" :maxlength="66"  v-model="form.expectSalary" ref="expectSalary"></el-input>
            </el-form-item>
            <el-form-item v-if="scoreType === '11'" label="综合评价" required >
                <el-input class="text-content" :maxlength="2000" placeholder="请输入评价内容" type="textarea" v-model="form.content" ref="content"></el-input>
            </el-form-item>
            <el-form-item v-if="['12','13'].includes(scoreType) && turn === '0'" label="最快到岗时间" required >
                <el-date-picker
                    ref="lastEntryTime"
                    v-model="form.lastEntryTime"
                    align="left"
                    :editable="false"
                    valueFormat="yyyy-MM-dd"
                    placeholder="请选择日期">
                </el-date-picker>
            </el-form-item>
        </el-form>
        <div class="button-footer">
            <el-button type="primary" @click="submit">提交评估</el-button>
            <el-button @click="cancel">取消</el-button>
        </div>
    </div>
</template>

<script>
    import SelectMapMixin from 'mixins/selectMapMixin'
    import SocietyBaseForm from './society-form-base'
    import {
        scoreMapList,
        scoreProp,
        otherMapList,
        otherProp,
        skillMapList,
        skillProp
    } from '../libs'

    export default {
        mixins: [SelectMapMixin],
        extends: SocietyBaseForm,
        data () {
            return {
                scoreMapList,
                otherMapList,
                skillMapList,
                form: {
                    userViewpoint: '',
                    ...scoreProp,
                    ...skillProp,
                    ...otherProp,
                    monthBaseSalary: '',
                    monthCount: '',
                    otherWelfare: '',
                    expectSalary: '',
                    lastEntryTime: '',
                    content: ''
                }
            }
        },
        props: {
            isEdit: false,
            scoreType: null,
            turn: null,
            extInfo: null
        }
    }
</script>

<style lang="scss">
    @import "../evaluation-form";

    .evaluation-form-scoped .inner-row.inner-row--pma .el-form-item__content {
        .el-row + .el-row {
            border-top: 1px solid #dfe3ec;
        }
        .el-col {
            background: #fff;
            &.shorter {
                height: 56px;
                line-height: 56px;
            }
            &.required:before {
                content: '*';
                color: #ff4949;
                margin-right: 4px;
            }
        }
    }
        
</style>



// WEBPACK FOOTER //
// society-form-pma.vue?46c71a33